import { GET_PARAM, GET_PARAM_SUCCESS, GET_PARAM_ERROR} from './actionTypes';

const initialState = {
    errorGetPARAM: "",
    loadingGetPARAM: false,
    param: null,
    successPARAM: ""
}

const getPARAM = (state = initialState, action) => {
    switch (action.type) {
        case GET_PARAM:
            state = {
                ...state,
                loadingGetPARAM: true
            }
            break;
        case GET_PARAM_SUCCESS:
            state = {
                ...state,
                loadingGetPARAM: false,
                param: action.payload.param, 
                successPARAM: action.payload.message
            }
            break;
        case GET_PARAM_ERROR:
            state = { ...state, errorGetPARAM: action.payload, loadingGetPARAM: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getPARAM;